export class MotivationUtil {
  public static readonly pointActivityCenterRouteName = 'tzy_motivation_point_mall'
}
